import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  CardContent, 
  Grid, 
  Chip,
  Divider,
  Paper
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import PersonIcon from '@mui/icons-material/Person';

const Locations: React.FC = () => {
  const branches = [
    {
      name: 'Head Office',
      manager: 'Mr C. Shamuyarira',
      address: '12 Lawson Avenue, Harare',
      phone: '+263-242-792822/24',
      isHeadOffice: true
    },
    {
      name: 'Harare Branch',
      manager: 'Mr C. Shamuyarira',
      address: '45 Robson Manyika, Harare',
      phone: '+263-242-792822/24'
    },
    {
      name: 'Bulawayo Branch',
      manager: 'Mr S. Chiwore',
      address: 'Stanbic Building, First Floor, Corner JM Nkomo and 8th Avenue',
      phone: '+263-29-74871/2/24'
    },
    {
      name: 'Gweru Branch',
      manager: 'Mr C. Mutandwa',
      address: '1st Floor, CAIPF Telone Building, FD11 7th Street',
      phone: '+263-254-22131/2'
    },
    {
      name: 'Masvingo Branch',
      manager: 'Mr S. Kunakah',
      address: 'Old Mutual House 1st floor, Robert Mugabe Street, P.O.Box 821 Masvingo',
      phone: '+263-239-26364/25/24'
    },
    {
      name: 'Mutare Branch',
      manager: 'Contact Head Office',
      address: 'Mutare City Center',
      phone: '+263-242-792822/24'
    },
    {
      name: 'Bindura Branch',
      manager: 'Contact Head Office',
      address: 'Bindura City Center',
      phone: '+263-242-792822/24'
    },
    {
      name: 'Lupane Branch',
      manager: 'Contact Head Office',
      address: 'Lupane City Center',
      phone: '+263-242-792822/24'
    }
  ];

  return (
    <Box sx={{ p: 3, maxWidth: 1200, mx: 'auto' }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, color: 'primary.main' }}>
        <LocationOnIcon sx={{ mr: 1, verticalAlign: 'middle' }} />
        SMEDCO Branch Locations
      </Typography>
      
      <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
        Find the nearest SMEDCO branch to you. We have offices across Zimbabwe to serve you better.
      </Typography>

      <Grid container spacing={3}>
        {branches.map((branch, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <Card 
              sx={{ 
                height: '100%',
                border: branch.isHeadOffice ? '2px solid' : '1px solid',
                borderColor: branch.isHeadOffice ? 'primary.main' : 'grey.300',
                '&:hover': {
                  boxShadow: 3,
                  transform: 'translateY(-2px)',
                  transition: 'all 0.3s ease'
                }
              }}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                  <Typography variant="h6" sx={{ fontWeight: 600, flexGrow: 1 }}>
                    {branch.name}
                  </Typography>
                  {branch.isHeadOffice && (
                    <Chip 
                      label="Head Office" 
                      color="primary" 
                      size="small"
                      sx={{ ml: 1 }}
                    />
                  )}
                </Box>

                <Box sx={{ mb: 2 }}>
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <PersonIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20 }} />
                    <Typography variant="body2" color="text.secondary">
                      Manager: {branch.manager}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
                    <LocationOnIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20, mt: 0.2 }} />
                    <Typography variant="body2" color="text.secondary">
                      {branch.address}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <PhoneIcon sx={{ mr: 1, color: 'text.secondary', fontSize: 20 }} />
                    <Typography 
                      variant="body2" 
                      color="primary.main"
                      sx={{ 
                        cursor: 'pointer',
                        '&:hover': { textDecoration: 'underline' }
                      }}
                      onClick={() => {
                        // Copy phone number to clipboard
                        navigator.clipboard.writeText(branch.phone);
                        alert(`Phone number copied: ${branch.phone}`);
                      }}
                    >
                      {branch.phone}
                    </Typography>
                  </Box>
                </Box>

                <Divider sx={{ my: 2 }} />

                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Typography 
                    variant="button" 
                    color="primary"
                    sx={{ 
                      cursor: 'pointer',
                      fontSize: '0.75rem',
                      '&:hover': { textDecoration: 'underline' }
                    }}
                    onClick={() => {
                      // Open maps with the address
                      const encodedAddress = encodeURIComponent(branch.address);
                      window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
                    }}
                  >
                    View on Map
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Paper sx={{ p: 3, mt: 4, bgcolor: 'primary.50' }}>
        <Typography variant="h6" gutterBottom sx={{ color: 'primary.main' }}>
          General Contact Information
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>Email:</strong> enquiries@smedco.co.zw<br />
          <strong>Website:</strong> https://smedco.co.zw<br />
          <strong>Business Hours:</strong> Monday - Friday, 8:00 AM - 5:00 PM
        </Typography>
      </Paper>
    </Box>
  );
};

export default Locations;
